<div class="routed-container">
  <div class="routed-content justify-center items-center flex flex-col w-full" #routedContainer>
    <div class="flex gap-2 items-center w-100">
      <a [routerLink]="['/clients']" class="back-button flex items-center justify-center gap-2 no-decoration">
        <i class="material-icons">arrow_back</i>
        <span>Back</span>
      </a>
      <h2 class="w-70 center-text">Client Information</h2>
    </div>
    <!-- Employee Details-->
    <ng-container *ngIf="loadingClient; else clientDetails">
      <div class="loader">
        <mat-spinner color="warn" [diameter]="50"></mat-spinner>
      </div>
    </ng-container>
    <!-- User Agents -->
     <ng-container *ngIf="loadingClient; else userAgents">
     </ng-container>
    <!-- Client Agreements -->
    <div class="card w-100 std-mb std-mt" *ngIf="!loadingClient && client?.client_id">
      <app-agreement-section
      [sectionTitle]="'Associated Agreements'"
      [client_id]="client?.client_id"
      [client_name]="client?.client_name"
      [displayVenueName]="true"
      ></app-agreement-section>
    </div>
  </div>
</div>


<!-- Templates -->
<ng-template #clientDetails>
  <div class="card w-100">
    <div class="header-info">
        <h3>Client Details</h3>
        <button class="edit-button" (click)="showClientDetailsEditModal()">
          Edit
        </button>
      </div>
    <div class="list-container">
      <div class="list-item">
          <strong>Client Name</strong>
          <p>
            {{ client?.client_name  }}
          </p>
          <span class="spacer"></span>
      </div>
      <div class="list-item">
          <strong>Company Name</strong>
          <p>
            {{ client?.company_name  }}
          </p>
          <span class="spacer"></span>
      </div>
      <div class="list-item">
          <strong>Billing Frequency</strong>
          <p class="text-capitalize">
            {{ client?.billing_frequency  }}
          </p>
          <span class="spacer"></span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #clientDetailsEditContent>
  <div class="input-group">
    <label for="fname">Client Name</label>
    <input type="text" [(ngModel)]="clientEditData.client_name" id="fname" class="textbox p-10" />
  </div>
  <div class="input-group">
    <label for="lname">Company Name</label>
    <input type="text" [(ngModel)]="clientEditData.company_name" id="lname" class="textbox p-10" />
  </div>
  <div class="input-group">
    <label for="status">Billing Frequency</label>
    <select class="textbox p-10" id="status" [(ngModel)]="clientEditData.billing_frequency">
      <option value="weekly">Weekly</option>
      <option value="monthly">Monthly</option>
      <option value="net30">Net 30</option>
    </select>
  </div>

  <p class="error-message" *ngIf="modalErrorMessage">{{ modalErrorMessage }}</p>
  <p class="success-message" *ngIf="modalSuccessMessage">{{ modalSuccessMessage }}</p>

</ng-template>

<ng-template #userAgents>
  <div class="card w-100 std-mt">
    <div class="header-info">
      <h3>User Agents</h3>
    </div>
    <div class="list-container" *ngIf="agents.length; else noAgents">
      <div class="list-item" *ngFor="let agent of agents">
        <strong>{{ agent.name }}</strong>
        <p class="text-capitalize">
          {{ agent.role }}
        </p>
        <span class="spacer"></span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #noAgents>
  <div class="center-text p-20">
    No User Agents Found
  </div>
</ng-template>

<!-- MODALS -->
 <app-basic-modal *ngIf="editClientDetailsIsActive" [template]="clientDetailsEditContent" [hideX]="true"
  [staticBackground]="false" [title]="'Edit Basic Information'" [cancel]="'Close'"
  (doCancel)="closeModal()" [action]="isSavingModal ? 'Saving...' : 'Save'"
  (doAction)="updateClientDetails()" [disabled]="disableModalSaveButton">
</app-basic-modal>
